webpackJsonp([18],{

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterOpensalud_vue__ = __webpack_require__(2653);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b16847b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterOpensalud_vue__ = __webpack_require__(2855);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterOpensalud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b16847b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterOpensalud_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/public/footers/FooterOpensalud.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b16847b", Component.options)
  } else {
    hotAPI.reload("data-v-0b16847b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ISO27001Logo'
});

/***/ }),

/***/ 2468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_routeHelpers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_GroupLinks__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_AddToHomeScreen__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ISO27001Logo__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var messages = {
  es: {
    'all-rights': 'Todos los derechos reservados.'
  },
  en: {
    'all-rights': 'All rights reserved.'
  },
  pt: {
    'all-rights': 'Todos os direitos reservados.'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseFooter',
  components: {
    GroupLinks: __WEBPACK_IMPORTED_MODULE_1__components_base_GroupLinks__["a" /* default */],
    AddToHomeScreen: __WEBPACK_IMPORTED_MODULE_2__components_utils_AddToHomeScreen__["a" /* default */],
    ISO27001Logo: __WEBPACK_IMPORTED_MODULE_3__components_utils_ISO27001Logo__["a" /* default */]
  },
  i18n: {
    messages: {
      es: messages.es,
      en: messages.en,
      mx: messages.es
    }
  },
  props: {
    logo: {
      type: String,
      default: function _default() {
        return !__WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__["l" /* inMx */] ? '' + __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["b" /* LOGOS_PATH */] + __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["l" /* OPENSALUD_WHITE_LOGO */] : '' + __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["b" /* LOGOS_PATH */] + __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["k" /* OPENSALUD_MX_WHITE_LOGO */];
      }
    },
    links: {
      type: Object,
      required: true
    },
    href: {
      type: String,
      required: false
    },
    socialLinks: {
      type: Array,
      required: false,
      default: function _default() {
        return [{
          href: 'https://www.facebook.com/opensalud/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg',
          alt: 'opensalud social facebook'
        }, {
          href: 'https://www.instagram.com/opensalud/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg',
          alt: 'opensalud social instagram'
        }, {
          href: 'https://www.linkedin.com/company/10606222?trk=tyah&amp;trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A10606222%2Cidx%3A1-1-1%2CtarId%3A1461928785973%2Ctas%3Aopensalud',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg',
          alt: 'opensalud social linkedin'
        }, {
          href: 'https://www.twitter.com/opensalud',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter.svg',
          alt: 'opensalud social twitter'
        }];
      }
    },
    companyName: {
      type: String,
      required: false,
      default: 'Open Healthcare'
    }
  },
  methods: {
    setTarget: function setTarget() {
      return '_blank';
    },
    isExternalLink: function isExternalLink(link) {
      return link && link.indexOf('http') === 0;
    }
  },
  computed: {
    isHealthApp: function isHealthApp() {
      return this.$route.meta.theme !== 'openlegal' && this.companyName !== 'Abogality Pro';
    },
    marginTopActive: function marginTopActive() {
      return __WEBPACK_IMPORTED_MODULE_0__router_routeHelpers__["a" /* default */].routeHasReducedLayout(this.$route);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var footer = document.querySelector('footer');
      var content = document.querySelector('.velmld-parent');
      if (!footer || !content) {
        return;
      }
      var footerHeight = footer.offsetHeight;
      var contentHeight = content.offsetHeight;
      if (footerHeight + contentHeight < window.innerHeight) {
        content.style.minHeight = window.innerHeight - footerHeight + 'px';
      }
    });
  }
});

/***/ }),

/***/ 2469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_countries__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_locales__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GroupLinks',
  data: function data() {
    return {
      inMx: __WEBPACK_IMPORTED_MODULE_2__helpers_global_helpers__["l" /* inMx */]
    };
  },

  computed: {
    opensaludLink: function opensaludLink() {
      return this.$helpers.getV2AppUrl('?langpref=' + (__WEBPACK_IMPORTED_MODULE_2__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_0__constants_countries__["c" /* MX_COUNTRY */] : __WEBPACK_IMPORTED_MODULE_0__constants_countries__["a" /* ES_COUNTRY */]) + this.$i18n.locale);
    },
    opensaludEsLink: function opensaludEsLink() {
      return this.$helpers.getV2AppUrl('?langpref=' + __WEBPACK_IMPORTED_MODULE_0__constants_countries__["a" /* ES_COUNTRY */] + (this.$i18n.locale === __WEBPACK_IMPORTED_MODULE_1__constants_locales__["c" /* MX_LOCALE */] ? __WEBPACK_IMPORTED_MODULE_1__constants_locales__["b" /* ES_LOCALE */] : this.$i18n.locale), true, false);
    },
    opensaludMxLink: function opensaludMxLink() {
      return this.$helpers.getV2AppUrl('?langpref=' + __WEBPACK_IMPORTED_MODULE_0__constants_countries__["c" /* MX_COUNTRY */] + (this.$i18n.locale === __WEBPACK_IMPORTED_MODULE_1__constants_locales__["b" /* ES_LOCALE */] ? __WEBPACK_IMPORTED_MODULE_1__constants_locales__["c" /* MX_LOCALE */] : this.$i18n.locale), false, true);
    }
  }
});

/***/ }),

/***/ 2490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ISO27001Logo_vue__ = __webpack_require__(2434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f87180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ISO27001Logo_vue__ = __webpack_require__(2493);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2491)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ISO27001Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f87180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ISO27001Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/ISO27001Logo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28f87180", Component.options)
  } else {
    hotAPI.reload("data-v-28f87180", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("731791b8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28f87180\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ISO27001Logo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28f87180\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ISO27001Logo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2492:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://opensaludes.sharepoint.com/:b:/s/General2/EewHuG8R5t1BnvqeB1acUVUBNx-umeNWcdrRgYyuwB2dug?e=tfdM2E",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "vertical middle-icon",
          attrs: {
            alt: "ISO 27001 OCA logo",
            src:
              "/static-appopensalud/img/icons/morillas-svg-icons/Logo/27001.png"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f87180", esExports)
  }
}

/***/ }),

/***/ 2508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFooter_vue__ = __webpack_require__(2468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3604ef0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseFooter_vue__ = __webpack_require__(2515);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2509)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3604ef0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3604ef0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/BaseFooter.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3604ef0a", Component.options)
  } else {
    hotAPI.reload("data-v-3604ef0a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2509:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2510);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6a36e475", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3604ef0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseFooter.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3604ef0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseFooter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2510:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3604ef0a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3604ef0a],.slide-down-leave-active[data-v-3604ef0a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3604ef0a],.slide-down-leave-to[data-v-3604ef0a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3604ef0a],.slide-fade-left-leave-active[data-v-3604ef0a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3604ef0a],.slide-fade-left-leave-to[data-v-3604ef0a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3604ef0a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3604ef0a],.fade-leave-to[data-v-3604ef0a]{opacity:0\n}\n.neu-card[data-v-3604ef0a]{border-radius:23px;display:block\n}\n.neu-card[data-v-3604ef0a]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card.black[data-v-3604ef0a]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card[data-v-3604ef0a]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card[data-v-3604ef0a]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card[data-v-3604ef0a]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-3604ef0a]{padding:5rem 3rem\n}\n}\n.neu-card-icon[data-v-3604ef0a]{border-radius:23px;display:block\n}\n.neu-card-icon[data-v-3604ef0a]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-icon.black[data-v-3604ef0a]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-icon[data-v-3604ef0a]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-icon[data-v-3604ef0a]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-icon[data-v-3604ef0a]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-icon[data-v-3604ef0a]{padding:5rem 3rem\n}\n}\n.neu-card-price[data-v-3604ef0a]{border-radius:23px;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.neu-card-price[data-v-3604ef0a]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-price.black[data-v-3604ef0a]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-price[data-v-3604ef0a]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-price[data-v-3604ef0a]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-price[data-v-3604ef0a]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-price[data-v-3604ef0a]{padding:5rem 3rem\n}\n}\n[data-v-3604ef0a].cert-icons{margin-left:auto !important\n}\n[data-v-3604ef0a].cert-icons div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n[data-v-3604ef0a].cert-icons div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n[data-v-3604ef0a].cert-icons div img.vertical{height:140px\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons div img.vertical{height:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons div img.vertical{height:70px\n}\n}\n[data-v-3604ef0a].cert-icons div img:not(.vertical){width:140px\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons div img:not(.vertical){width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons div img:not(.vertical){width:70px\n}\n}\n[data-v-3604ef0a].cert-icons-footer{margin-left:auto !important\n}\n[data-v-3604ef0a].cert-icons-footer div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n[data-v-3604ef0a].cert-icons-footer div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n[data-v-3604ef0a].cert-icons-footer div img.first-icon{width:130px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons-footer div img.first-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons-footer div img.first-icon{width:70px\n}\n}\n[data-v-3604ef0a].cert-icons-footer div img.last-icon{width:150px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons-footer div img.last-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons-footer div img.last-icon{width:70px\n}\n}\n[data-v-3604ef0a].cert-icons-footer div img.middle-icon{width:80px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-3604ef0a].cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-3604ef0a].cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.my-0-manuel[data-v-3604ef0a]{margin-top:0 !important;margin-bottom:0 !important\n}\n}\n@media only screen and (min-width: 1024px){\n.mb-xl-6[data-v-3604ef0a]{margin-bottom:3rem !important\n}\n}\nfooter[data-v-3604ef0a]{text-align:left;text-transform:uppercase;padding-top:6rem;padding-bottom:6rem;background-color:#1D1D1E;color:#eee\n}\nfooter a[data-v-3604ef0a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\nfooter .stick-bottom[data-v-3604ef0a]{position:absolute;bottom:0;width:100vw\n}\n@media only screen and (min-width: 1024px){\nfooter[data-v-3604ef0a]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\nfooter[data-v-3604ef0a]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\nfooter[data-v-3604ef0a]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nfooter[data-v-3604ef0a]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\nfooter[data-v-3604ef0a]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\nfooter[data-v-3604ef0a]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\nfooter[data-v-3604ef0a]{padding-top:3rem\n}\n}\n@media only screen and (min-width: 1024px){\nfooter .logo div[data-v-3604ef0a]{float:right\n}\n}\n@media only screen and (max-width: 575px){\nfooter .logo div[data-v-3604ef0a]{float:none\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nfooter .logo div[data-v-3604ef0a]{float:none\n}\n}\nfooter .logo img[data-v-3604ef0a]{width:200px\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nfooter .logo img[data-v-3604ef0a]{width:135px\n}\n}\n@media only screen and (max-width: 575px){\nfooter .logo img[data-v-3604ef0a]{width:135px\n}\n}\nfooter .links-block div[data-v-3604ef0a]{border-top:1px solid;padding-top:2rem;display:inline-block\n}\nfooter .links-block div a[data-v-3604ef0a]{padding-bottom:1rem;color:#eee;display:block;-webkit-transition-duration:.5s;transition-duration:.5s\n}\nfooter .links-block div a[data-v-3604ef0a]:hover{text-decoration:none;margin-left:0.5rem;-webkit-transition-duration:.5s;transition-duration:.5s\n}\nfooter .social-icons a[data-v-3604ef0a]{margin-right:2rem;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex\n}\nfooter .social-icons a img[data-v-3604ef0a]{-webkit-transform:scale(1);transform:scale(1);-webkit-transition-duration:.5s;transition-duration:.5s;max-width:1.75rem\n}\nfooter .social-icons a:hover img[data-v-3604ef0a]{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transition-duration:.5s;transition-duration:.5s\n}\n@media only screen and (min-width: 1024px){\nfooter .copyright>div[data-v-3604ef0a]{float:right\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nfooter .copyright>div[data-v-3604ef0a]{float:none\n}\n}\n@media only screen and (max-width: 575px){\nfooter .copyright>div[data-v-3604ef0a]{float:none\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupLinks_vue__ = __webpack_require__(2469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3bfe90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupLinks_vue__ = __webpack_require__(2514);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2512)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c3bfe90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3bfe90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/GroupLinks.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c3bfe90", Component.options)
  } else {
    hotAPI.reload("data-v-5c3bfe90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4a1a9e3b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c3bfe90\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GroupLinks.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c3bfe90\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GroupLinks.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-5c3bfe90]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-5c3bfe90],.slide-down-leave-active[data-v-5c3bfe90]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-5c3bfe90],.slide-down-leave-to[data-v-5c3bfe90]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-5c3bfe90],.slide-fade-left-leave-active[data-v-5c3bfe90]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-5c3bfe90],.slide-fade-left-leave-to[data-v-5c3bfe90]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-5c3bfe90]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-5c3bfe90],.fade-leave-to[data-v-5c3bfe90]{opacity:0\n}\n.lang-cnt[data-v-5c3bfe90]{color:#eee;display:block;-webkit-transition:all 0.3s ease;transition:all 0.3s ease\n}\n.lang-cnt span[data-v-5c3bfe90]:not(.separator),.lang-cnt a[data-v-5c3bfe90]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase;cursor:pointer;color:white\n}\n.lang-cnt span[data-v-5c3bfe90]:not(.separator):not(.country-label):hover,.lang-cnt a[data-v-5c3bfe90]:not(.country-label):hover{text-decoration:underline\n}\n.lang-cnt span:not(.separator).country-label[data-v-5c3bfe90],.lang-cnt a.country-label[data-v-5c3bfe90]{cursor:initial\n}\n.lang-cnt span[data-v-5c3bfe90]:not(.separator):not(:last-child),.lang-cnt a[data-v-5c3bfe90]:not(:last-child){margin-right:2rem\n}\n.lang-cnt span:not(.separator).active[data-v-5c3bfe90],.lang-cnt a.active[data-v-5c3bfe90]{border-top:2px solid #3238C4\n}\n", ""]);

// exports


/***/ }),

/***/ 2514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-cnt" }, [
    _c("a", { attrs: { href: _vm.opensaludLink, target: "_blank" } }, [
      _vm._v("OPENSALUD")
    ]),
    _vm._v(" "),
    !_vm.inMx
      ? _c("a", { attrs: { href: _vm.opensaludMxLink } }, [
          _vm._v("OPENSALUD MEXICO")
        ])
      : _c("a", { attrs: { href: _vm.opensaludEsLink } }, [
          _vm._v("OPENSALUD ESPAÑA")
        ]),
    _vm._v(" "),
    !_vm.inMx
      ? _c("a", { attrs: { href: "https://menttum.com", target: "_blank" } }, [
          _vm._v("MENTTUM")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      { attrs: { href: _vm.$helpers.get360AppUrl(), target: "_blank" } },
      [_vm._v("OPENSALUD360")]
    ),
    _vm._v(" "),
    !_vm.inMx
      ? _c(
          "a",
          {
            attrs: {
              href: _vm.$helpers.getV2AppUrl("opensalud4all"),
              target: "_blank"
            }
          },
          [_vm._v("OPENSALUD4ALL")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c3bfe90", esExports)
  }
}

/***/ }),

/***/ 2515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$helpers.inIframe()
    ? _c(
        "footer",
        {
          class: { "mt-3": _vm.marginTopActive, "mt-lg-5": _vm.marginTopActive }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "links-block",
                  attrs: {
                    xl: _vm.links.thirdColumn ? 3 : 6,
                    md: "6",
                    sm: "12"
                  }
                },
                [
                  _c(
                    "div",
                    _vm._l(_vm.links.firstColumn, function(link, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !link.hide,
                              expression: "!link.hide"
                            }
                          ],
                          key: index
                        },
                        [
                          _vm.isExternalLink(link.href)
                            ? _c(
                                "a",
                                {
                                  attrs: { target: "_blank", href: link.href }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(link.text) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _c("router-link", { attrs: { to: link.href } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(link.text) +
                                    "\n            "
                                )
                              ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "links-block mt-3 mt-md-0",
                  attrs: { xl: "3", md: "6", sm: "12" }
                },
                [
                  _c(
                    "div",
                    _vm._l(_vm.links.secondColumn, function(link, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !link.hide,
                              expression: "!link.hide"
                            }
                          ],
                          key: index
                        },
                        [
                          _vm.isExternalLink(link.href)
                            ? _c(
                                "a",
                                {
                                  attrs: { target: "_blank", href: link.href }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(link.text) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _c("router-link", { attrs: { to: link.href } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(link.text) +
                                    "\n            "
                                )
                              ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _vm.links.thirdColumn
                ? _c(
                    "b-col",
                    {
                      staticClass: "links-block mt-3 mt-md-0",
                      attrs: { xl: "3", md: "6", sm: "12" }
                    },
                    [
                      _c(
                        "div",
                        _vm._l(_vm.links.thirdColumn, function(link, index) {
                          return _c(
                            "span",
                            { key: index },
                            [
                              _vm.isExternalLink(link.href)
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: link.href
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(link.text) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c(
                                    "router-link",
                                    { attrs: { to: link.href, tag: "a" } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(link.text) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "logo logo-footer mt-3 mt-xl-0",
                  attrs: { xl: "3", md: "12", sm: "12" }
                },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "d-block",
                        attrs: { target: "_blank", href: _vm.href }
                      },
                      [_c("img", { attrs: { src: _vm.logo } })]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", { staticClass: "cert-icons-footer mt-3" }, [
            _c("div", [
              _c("img", {
                staticClass: "middle-icon",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                staticClass: "first-icon",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/Logo/hipaa.png"
                }
              })
            ]),
            _vm._v(" "),
            _vm.isHealthApp ? _c("div", [_c("ISO27001Logo")], 1) : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("router-link", { attrs: { to: "/programa-pyme" } }, [
                  _c("img", {
                    staticClass: "last-icon",
                    attrs: {
                      src: "/static-appopensalud/img/logos/programapyme.png"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "social-icons py-xl-5 mt-3" },
            [
              _c(
                "b-col",
                { attrs: { xl: "3", sm: "12" } },
                [
                  _vm._l(_vm.socialLinks, function(link, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        attrs: { target: "_blank", href: link.href }
                      },
                      [_c("img", { attrs: { src: link.src, alt: link.alt } })]
                    )
                  }),
                  _vm._v(" "),
                  _c("AddToHomeScreen", {
                    staticClass: "mt-3",
                    attrs: { white: "" }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "copyright mt-3 mt-xl-0",
                  attrs: { xl: "9", sm: "12" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("group-links", { staticClass: "d-block mb-4" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "overline-typescale",
                          class: {
                            "d-block": true,
                            "text-right": !_vm.$uiHelpers.isMobile
                          }
                        },
                        [
                          _vm._v(
                            "Copyright © " +
                              _vm._s(new Date().getFullYear()) +
                              " " +
                              _vm._s(_vm.companyName) +
                              ". " +
                              _vm._s(_vm.$t("all-rights"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3604ef0a", esExports)
  }
}

/***/ }),

/***/ 2653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_footer_opensalud_json__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_footer_opensalud_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_public_footer_opensalud_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_footer_opensalud_json__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_footer_opensalud_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_public_footer_opensalud_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_footer_opensalud_json__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_footer_opensalud_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_pt_public_footer_opensalud_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_BaseFooter_vue__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterOpensalud',
  components: {
    BaseFooter: __WEBPACK_IMPORTED_MODULE_3__base_BaseFooter_vue__["a" /* default */]
  },
  i18n: {
    messages: {
      es: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_footer_opensalud_json___default.a,
      en: __WEBPACK_IMPORTED_MODULE_1__lang_en_public_footer_opensalud_json___default.a,
      mx: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_footer_opensalud_json___default.a,
      pt: __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_footer_opensalud_json___default.a
    }
  },
  data: function data() {
    return {
      links: {
        firstColumn: [{
          text: this.$t('professional-conditions'),
          href: '/terminos-condiciones-profesional'
        }, {
          text: this.$t('patient-conditions'),
          href: '/terminos-condiciones-paciente'
        }, {
          text: this.$t('companies-telemedicine'),
          href: '/opensalud360/empresas'
        }, {
          text: this.$t('contact'),
          href: '/contacto'
        }],
        secondColumn: [{
          text: this.$t('legal-notice'),
          href: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? '/aviso-legal-cookies' : '/aviso-legal'
        }, {
          text: this.$t('cookies-policy'),
          href: '/politica-cookies',
          hide: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */]
        }, {
          text: this.$t('privacy-policy'),
          href: '/politica-privacidad',
          hide: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */]
        }, {
          text: this.$t('privacy-policy-professional'),
          href: '/politica-privacidad-profesional',
          hide: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */]
        }, {
          text: this.$t('sgsi-policy'),
          href: '/politica-sgsi',
          hide: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */]
        }]
      }
    };
  }
});

/***/ }),

/***/ 2855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-footer", { attrs: { links: _vm.links } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b16847b", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/18.b78a98e97edb0c88fcbc.js